<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="m12.48 6.933-2.827-3.6L11.288 2 16 8l-4.712 6-1.635-1.333 2.827-3.6H0V6.933z"
    clip-rule="evenodd"
  />
</svg>
